import React, { Component, Suspense } from 'react';
import { BrowserRouter, Route, Redirect } from 'react-router-dom'
import './scss/index.scss'

import Pages from './pages'
import { UserAgent } from 'react-useragent';

class App extends Component {
  render() {
    return (
      <div className="App">
        <BrowserRouter>
          <Suspense fallback={<p>Loading...</p>}>
            <div>
              <div className="wrapper">
                <div>
                  <UserAgent>
                    {({ ua }) => {
                      return ua.mobile ? <>
                        <Route exact path="/lp" component={Pages.trial} />
                        <Route exact path="/lp/:id" component={Pages.lp} />
                        <Route path="/trial" component={Pages.trial} />
                      </> : <>
                        <Route exact path="/lp" component={Pages.trial} />
                        <Route exact path="/lp/:id" component={Pages.lp} />
                        <Route path="/trial" component={Pages.trial} />
                      </>;
                    }}
                  </UserAgent>
                  <Route path='/' exact component={() => { window.location.href = 'https://30min-lp.vercel.app/'; return null; }}/>
                  <Route path="/news/:id" component={Pages.news} />
                  <Route path="/subscription" component={Pages.subscription} />
                  <Route path="/subscription_form" component={Pages.subscription_form} />
                  <Route path="/subscription_done" component={Pages.subscription_done} />
                  <Route path="/trial_old" component={Pages.trial} />
                  <Route path="/trial_form" component={Pages.trial_form} />
                  <Route path="/trial_pc_form" component={Pages.trial_pc_form} />
                  <Route path="/trial_form_candidates" component={Pages.trial_form_candidates} />
                  <Route path="/trial_done" component={Pages.trial_done} />
                  <Route path="/trial_pc_done" component={Pages.trial_pc_done} />
                  <Route path="/limited" component={Pages.limited} />
                  <Route path="/employee" component={Pages.employee} />
                  <Route path="/app_ad" component={Pages.campaign_common} />
                  <Route path="/form" component={Pages.campaign_common_form} />
                  <Route path="/mjpm" component={Pages.mjpm} />
                  <Route path="/mjpm_form" component={Pages.mjpm_form} />
                  <Route path="/mjpm_done" component={Pages.mjpm_done} />
                  <Route path="/logout" component={Pages.logout} />
                  <Route path="/cast_agreement/:cast_id/:user_id/:reservation_id" component={Pages.cast_agreement} />
                  <Route path="/cast_agreements/:cast_id" component={Pages.cast_agreements} />
                  <Route path="/cast_done/" component={Pages.cast_done} />
                  <Route path="/admin_login" component={Pages.admin_login} />
                  <Route path="/admin_users" component={Pages.admin_users} />
                  <Route path="/admin_users_deleted" component={Pages.admin_users_deleted} />
                  <Route path="/admin_casts" component={Pages.admin_casts} />
                  <Route path="/admin_reservations" component={Pages.admin_reservations} />
                  <Route path="/admin_debug" component={Pages.admin_debug} />

                  <Route path="/trial_community"><Redirect to="/" /></Route>
                  <Route path="/trial_fb"><Redirect to="/" /></Route>
                  <Route path="/trial_bayarea"><Redirect to="/" /></Route>
                  <Route path="/april_magazine"><Redirect to="/" /></Route>
                  <Route path="/trial_magazine"><Redirect to="/" /></Route>
                  <Route path="/trial_magazine/:section"><Redirect to="/" /></Route>
                  <Route path="/daycare"><Redirect to="/" /></Route>
                  <Route path="/campaign"><Redirect to="/" /></Route>
                  <Route path="/newyear2021"><Redirect to="/" /></Route>
                </div>
              </div>
            </div>
          </Suspense>
        </BrowserRouter>
      </div>
    );
  }
}

/*
function NotFound() {
  return (
    <div className="notfound">
      <div className="message">
        <h2>404</h2>
        <h1>お探しのページが見つかりません。</h1>
        <p>指定されたページが見つかりませんでした。 URLに誤りがないかご確認いただき、再試行をお願いいたします。</p>
        <p><a href="https://30min.page/">トップへ</a></p>
      </div>
    </div>
  );
}
*/

export default App;
